import { useEffect, useState } from 'react';
import { getContextMenu } from '../../service/areena-api/fetchers';
import { Control, Pointer } from '@yleisradio/areena-types';
import { logger } from '../../common/logger';

type Grouping = {
  controls: Control[];
  groupings: Grouping[];
  type: 'grouping';
};

export type ContextMenuResponse = {
  data: ContextMenuData;
  apiVersion: string;
  meta: unknown;
};

export type ContextMenuData = {
  groupings: Grouping[];
  type: 'menu';
};

export function useContextMenu(pointer?: Pointer) {
  const [data, setData] = useState<Control[]>([]);

  const mapControls = (contextMenu: ContextMenuResponse): Control[] => {
    if (contextMenu.data.type !== 'menu') {
      logger.error('Invalid context menu type:', contextMenu.data.type);
      return [];
    }

    const controls: Control[] = [];
    contextMenu.data.groupings.forEach(grouping => {
      grouping.controls.forEach(control => {
        controls.push(control);
      });
    });

    return controls;
  };

  useEffect(() => {
    if (!pointer || !pointer.uri) {
      return;
    }

    getContextMenu(pointer)
      .then(res => {
        setData(mapControls(res));
      })
      .catch(error => {
        logger.error('Error fetching context menu:', error);
      });
  }, [pointer]);

  return { data };
}
